import {
  registerContinuousLegend,
  registerDiscreteLegend,
  registerCustomMark,
  registerAllMarks,
  registerTitle,
  registerTooltip,
  registerDomTooltipHandler,
  registerAnimate,
  registerReactAttributePlugin
} from '@visactor/vchart';

export const registers = [
  registerAnimate,
  registerReactAttributePlugin,
  registerTooltip,
  registerDomTooltipHandler,
  registerDiscreteLegend,
  registerContinuousLegend,
  registerCustomMark,
  registerAllMarks,
  registerTitle
];
